import { System } from './../../shared-components/System';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomPage } from './models/custom-page.model';
import { CustomField } from './models/custom-field.model';


@Injectable()
export class CustomPageService {

  constructor(
    private http: HttpClient
  ) { }

  public getCustomPage(dataModuleName: string, id: number, idFieldName: string, aYIdentifier: string): Observable<CustomPage[]> {
    let queryString = '';
    queryString += '?dataModuleName=' + dataModuleName;
    queryString += '&id=' + id;
    queryString += '&idFieldName=' + idFieldName;
    queryString += '&aYIdentifier=' + aYIdentifier;

    return this.http.get<CustomPage[]>(System.apiURL.Student + 'GetCustomPage' + queryString);
  }

  public saveFieldValues(fields: CustomField[], dataModuleName: string, id: number, idFieldName: string): Observable<void> {
    let queryString = '';
    queryString += '?dataModuleName=' + dataModuleName;
    queryString += '&id=' + id;
    queryString += '&idFieldName=' + idFieldName;

    return this.http.post<void>(System.apiURL.Student + 'SaveFieldValues' + queryString, fields);
  }

}
